import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer website designing services in Nagpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer professional and affordable website design and development services in Nagpur for businesses, startups, and individuals."
      }
    },
    {
      "@type": "Question",
      "name": "What is the starting cost of a website in Nagpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our basic website packages in Nagpur start from ₹10,000. The final price depends on the number of pages, features, and level of customization."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile-friendly and responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we ensure that all websites are fully mobile responsive and optimized for viewing on smartphones, tablets, and desktops."
      }
    },
    {
      "@type": "Question",
      "name": "Do you follow SEO best practices?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. Our websites are designed with SEO-friendly structure, fast loading speed, schema markup, and clean URLs to help you rank better."
      }
    },
    {
      "@type": "Question",
      "name": "Can I manage my website content on my own?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we use CMS platforms like WordPress that allow you to easily update your content, images, and blogs without technical knowledge."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide eCommerce development in Nagpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we build feature-rich eCommerce websites with product catalogs, shopping carts, secure payment integration, and order management."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to build a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Basic websites take around 5–7 working days. Larger or more customized projects may take 2–4 weeks depending on your requirements."
      }
    },
    {
      "@type": "Question",
      "name": "Do you help with domain registration and hosting?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we assist with domain name registration, hosting setup, SSL certificate installation, and email account configuration."
      }
    },
    {
      "@type": "Question",
      "name": "What post-launch support do you offer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We offer maintenance packages that include regular updates, performance checks, backups, and technical support to keep your website running smoothly."
      }
    },
    {
      "@type": "Question",
      "name": "How can I get started with a website in Nagpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can contact us via our website or phone. We'll schedule a consultation to understand your needs and provide a free quote."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Nagpur</title>
<meta name="description" content="Top website designer in Nagpur. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="website developer nagpur, web design company in nagpur, web design in nagpur, website designer in nagpur, website design company in nagpur, website development company in nagpur, web development company in nagpur, nagpur web design, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Nagpur" />
<meta property="og:description" content="Top Website Designer In Nagpur. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Nagpur" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-nagpur"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Nagpur" />
<meta name="twitter:description" content="Top website designer in Nagpur. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-nagpur" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer In Nagpur</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Nagpur</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Welcome to Pankaj's Web Design Services! Located in the heart of Nagpur, I specialize in crafting unique and effective websites that cater to the needs of businesses and individuals alike. With a focus on innovative design, functionality, and user experience, my goal is to help you establish a strong online presence that stands out in today’s competitive digital landscape.
<h3>My Services:</h3>
<h4><strong>Custom Website Design</strong></h4>
Your website is a reflection of your brand, and I believe it should be as unique as you are. I offer custom website design services tailored to your specific requirements, ensuring that your site is not only visually appealing but also user-friendly. Whether you need a professional corporate site, an engaging portfolio, or a feature-rich e-commerce platform, I am here to bring your vision to life.
<h4><strong>E-Commerce Solutions</strong></h4>
In the age of online shopping, having a robust e-commerce website is essential. I provide comprehensive e-commerce solutions that include secure payment gateways, intuitive navigation, and optimized product displays. My goal is to create an online store that enhances the shopping experience and drives sales.
<h4><strong>Responsive Web Development</strong></h4>
With an increasing number of users accessing websites via mobile devices, having a responsive design is crucial. I ensure that all websites I develop are fully responsive, providing a seamless experience across desktops, tablets, and smartphones. This adaptability helps retain visitors and improves overall user engagement.
<h4><strong>SEO-Friendly Websites</strong></h4>
Visibility on search engines is key to attracting organic traffic. I incorporate SEO best practices into every website I design, optimizing content, images, and site structure to improve your rankings on search engines like Google. This approach helps ensure that your target audience can find you easily online.
<h4><strong>Website Redesign</strong></h4>
If your current website isn’t meeting your expectations or feels outdated, I offer website redesign services to refresh and enhance your online presence. My redesign process focuses on modern aesthetics, improved functionality, and better user experience, ensuring your site aligns with your current business goals.
<h4><strong>Content Management Systems (CMS)</strong></h4>
I utilize popular content management systems such as WordPress, allowing you to manage your website content easily. With an intuitive interface, you can make updates and changes independently, giving you complete control over your site’s content.
<h4><strong>Maintenance &amp; Support</strong></h4>
After your website is launched, I provide ongoing maintenance and support services to keep everything running smoothly. From regular updates to troubleshooting, I’m here to assist you with any issues that may arise, ensuring your website remains functional and up-to-date.
<h4><strong>Digital Marketing &amp; SEO Services</strong></h4>
Beyond web design, I offer basic digital marketing services to help you enhance your online visibility. Whether through social media marketing, email campaigns, or content strategies, I can help you effectively reach and engage your target audience.
<h3>Why Choose Me?</h3>
<ul>
  <li><strong>Experience</strong>: With over ten years of experience in web design and development, I am dedicated to delivering high-quality results tailored to your needs.</li>
  <li><strong>Client-Focused Approach</strong>: I prioritize understanding your vision and goals, ensuring that the final product exceeds your expectations.</li>
  <li><strong>Affordable Pricing</strong>: I offer competitive rates for quality services that fit within your budget.</li>
  <li><strong>Timely Delivery</strong>: I am committed to delivering projects on schedule without compromising quality.</li>
</ul>
Let’s collaborate to create a stunning website that elevates your brand and connects with your audience. Contact me today for a consultation and a free quote!
<h2>Frequently Asked Questions</h2>

<h4>1. What services do you offer as a website designer?</h4>
<p>I offer a range of services, including custom website design, e-commerce solutions, responsive web development, SEO-friendly websites, website redesign, CMS implementation, ongoing maintenance and support, and digital marketing services.</p>

<h4>2. How long does it take to complete a website project?</h4>
<p>The timeline for completing a website project can vary depending on its complexity and your specific requirements. Typically, a basic website takes about 2-4 weeks, while more complex projects may require additional time. I will provide a detailed timeline during our initial consultation.</p>

<h4>3. Are your websites mobile-friendly?</h4>
<p>Yes! All websites I create are fully responsive, ensuring they look great and function properly on all devices, including desktops, tablets, and smartphones. This responsiveness is essential for providing a positive user experience.</p>

<h4>4. Can you assist with search engine optimization (SEO)?</h4>
<p>Absolutely! I incorporate SEO best practices into the design and development process to enhance your website's visibility on search engines. This includes optimizing content, images, and site structure to attract organic traffic.</p>

<h4>5. What kind of support do you provide after the website is launched?</h4>
<p>I offer ongoing maintenance and support services to ensure your website runs smoothly after launch. This includes routine updates, troubleshooting, and assistance with any issues that may arise.</p>

<h4>6. How can I update my website after it’s launched?</h4>
<p>If you choose a Content Management System (CMS) like WordPress, you will have the ability to manage and update your website content independently. I will provide training on how to do this, and I am available for additional support as needed.</p>

<h4>7. What is the estimated cost of your website design services?</h4>
<p>The cost of my website design services varies based on factors such as project complexity, required features, and your specific needs. I provide a free quote after discussing your project in detail to ensure it fits your budget.</p>

<h4>8. Can you redesign my existing website?</h4>
<p>Yes, I offer website redesign services to refresh and enhance your current site. This can involve updating the layout, improving functionality, and optimizing for better performance and user experience.</p>

<h4>9. How do we get started on a project together?</h4>
<p>To begin, simply contact me through my website or reach out via email or phone. We’ll schedule a consultation to discuss your project goals, timeline, and budget, allowing us to create a customized plan for your website.</p>

<h4>10. Why should I choose you as my website designer in Nagpur?</h4>
<p>With over ten years of experience, a commitment to quality, and a client-centric approach, I am dedicated to helping you create a website that meets your needs and exceeds your expectations. Your satisfaction is my top priority!</p>

          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
